export var MediaType;
(function (MediaType) {
    MediaType["VIDEO"] = "VIDEO";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["YOUTUBE"] = "YOUTUBE";
})(MediaType || (MediaType = {}));
/**
 * status of the listing, DRAFT for the current market listing in the Dev Center,
 * and PUBLISHED for the published market listing in the App Market.
 */
export var Status;
(function (Status) {
    /** current market listing in the Dev Center. */
    Status["DRAFT"] = "DRAFT";
    /** published market listing in the App Market. */
    Status["PUBLISHED"] = "PUBLISHED";
    /** approved market listing in the App Market. */
    Status["APPROVED"] = "APPROVED";
})(Status || (Status = {}));
export var Classification;
(function (Classification) {
    /** A Regular app entity - used to installed on sites. */
    Classification["SITE_APP"] = "SITE_APP";
    /** represents an account API KEY to access wix services. */
    Classification["API_KEY"] = "API_KEY";
    /** represents an app developed for Velo editor. */
    Classification["VELO_APP"] = "VELO_APP";
    /** Private App that should be available only for the owner account / sub-accounts. */
    Classification["PRIVATE_APP"] = "PRIVATE_APP";
    /** represents an External Headless (3rd party) App that has access to Wix Public Services */
    Classification["HEADLESS"] = "HEADLESS";
})(Classification || (Classification = {}));
export var VersionStatus;
(function (VersionStatus) {
    /** default, internal use status. do not use */
    VersionStatus["NONE_STATUS"] = "NONE_STATUS";
    /** a version which was created in the dev center and has not started the approval process yet */
    VersionStatus["DRAFT"] = "DRAFT";
    /** the version was submitted for review by the developer */
    VersionStatus["SUBMITTED"] = "SUBMITTED";
    /** the version is being reviewed by the app market team in cactus */
    VersionStatus["IN_REVIEW"] = "IN_REVIEW";
    /** our team approved the version */
    VersionStatus["APPROVED"] = "APPROVED";
    /** this version is published - only one version can be published at any given time; if this app was already published, the previously published version's status is now ARCHIVED */
    VersionStatus["PUBLISHED"] = "PUBLISHED";
    /** our team did not accept this version of the app */
    VersionStatus["DECLINED"] = "DECLINED";
    /** the status for versions that are no longer relevant */
    VersionStatus["ARCHIVED"] = "ARCHIVED";
    /** status for versions with no significant changes, e.g. for test app. for questions contact our team */
    VersionStatus["HIDDEN"] = "HIDDEN";
    /** mark apps as RELEASED, without adding to the apps cache, and allow users to install */
    VersionStatus["RELEASED"] = "RELEASED";
})(VersionStatus || (VersionStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map